import React from "react";
import { styled, keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`;

const Shimmer = styled.div`
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colorSurfaceVariant} 25%,
    ${({ theme }) => theme.colorSurface} 50%,
    ${({ theme }) => theme.colorSurfaceVariant} 75%
  );
  background-size: 1200px 100%;
  animation: ${shimmer} 1.4s infinite linear;
  border-radius: ${(props) => props.radius || "8px"};
`;

const Container = styled.div`
  width: ${(props) => (props.type === "sm" ? "auto" : "100%")};
  display: ${(props) => props.type === "sm" && "flex"};
  gap: 8px;
  cursor: default;
`;

const ThumbnailSkeleton = styled(Shimmer)`
  width: ${(props) => (props.type === "sm" ? "168px" : "100%")};
  height: ${(props) => (props.type === "sm" ? "94px" : "auto")};
  aspect-ratio: ${(props) => props.type !== "sm" && "16 / 9"};
  flex-shrink: 0;
  border-radius: 14px;
`;

const Details = styled.div`
  display: flex;
  margin-top: ${(props) => props.type !== "sm" && "8px"};
  gap: 12px;
  flex: 1;
`;

const AvatarSkeleton = styled(Shimmer)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex: none;
  display: ${(props) => props.type === "sm" && "none"};
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  padding-top: 2px;
`;

const LineSkeleton = styled(Shimmer)`
  height: ${(props) => props.height || "14px"};
  width: ${(props) => props.width || "100%"};
  border-radius: 6px;
`;

const RecipeCardSkeleton = ({ type }) => (
  <Container type={type}>
    <ThumbnailSkeleton type={type} />
    <Details type={type}>
      <AvatarSkeleton type={type} />
      <Texts>
        <LineSkeleton height="16px" width="85%" />
        <LineSkeleton height="14px" width="55%" />
        <LineSkeleton height="12px" width="40%" />
      </Texts>
    </Details>
  </Container>
);

export default RecipeCardSkeleton;
